import React, { useState } from 'react'
import { Grid } from '@mui/material'
import Box from '@mui/material/Box';
import { FormControl, TextField } from '@mui/material';
import RemoveIcon from "../../../images/remove.png"
import PlusIcon from "../../../images/plus_icon.png"
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import ApiClient from '../../common/ApiClient';
import { useEffect } from 'react';
import DeleteDialog from '../DeleteDialog';
import { useParams } from 'react-router-dom';
import styles from "../../ott/OttPlatform/Stream.module.css"


import { getRequestGlobal } from "../../../API/global"
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import { Margin } from '@mui/icons-material';
import Loader from '../../common/Loader/Loader';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import AddBoxIcon from '@mui/icons-material/AddBox';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import DdAPI from '../../API/DdAPI';


const IpAward = ({ setFormDataMain, setOtherErrors, errors, formDataMain }) => {

    // const [reducerValue, forceUpdate] = useReducer(x => x + 1, 0);
    const [loading, setLoading] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertSeverity, setAlertSeverity] = useState("success");

    const { id = null } = useParams();
    const { putRequest, getRequest, deleteRequest } = DdAPI();

    const [errorsForm, setErrorsForm] = useState({});
    const [preData, setPreData] = useState([]);
    const [showForm, setShowForm] = useState(true)
    const [maximumLimitReach, setMaximumLimitReach] = useState(true);
    const [formData, setFormData] = React.useState({

        details: '',
        dd_application_form_id: id,

    });
    const loadData = async () => {
        const preData = await getRequest(`${id}/dd-award`);
        const data = preData.data;
        // console.log('testfilmdata', data)
        if (data.length > 0) {
            setShowForm(false)
            setFormDataMain(prevData => ({
                ...prevData
            }));
            setOtherErrors({
                ...errors
            })
            if (data.length >= 5) {
                setMaximumLimitReach(false)
            } else {
                setMaximumLimitReach(true)
            }
        } else {
            setShowForm(true)
            setFormDataMain(prevData => ({
                ...prevData
            }));
        }

        setPreData(data);
    }
    useEffect(() => {
        loadData();

    }, []);



    const validateForm = () => {
        const newErrors = {};
        if (!formData.details) newErrors.details = 'Details of Award missing';
        if (!formData.dd_application_form_id) newErrors.dd_application_form_id = 'form id  is missing';
        setErrorsForm(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleFormData = (e) => {
        const { name, value } = e.target;
        // console.log("sdsfsdfsdfsdfds")
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
        errorsForm[name] = ""
        setErrorsForm(errorsForm);

    };
    const handleChangeDateOfFestival = (e) => {
        if (e) {
            const formattedDate = e.format('YYYY-MM-DD');
            setFormData(prevData => ({
                ...prevData,
                release_date: dayjs(formattedDate)
            }));
        }

        // Clear the error message forrelease_date
        setOtherErrors(prevErrors => ({
            ...prevErrors,
            release_date: ""
        }));
    }
    const Addmore = async (e) => {
        setShowForm(true)
    }
    const mini = async (e) => {
        setShowForm(false)
    }

    const submitForm = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;
        setLoading(true)
        try {

            const response = await putRequest(`${id}/dd-award`, formData)

            if (!response.status) {
                throw new Error(`Error: ${response.status} ${response.statusText}`);
            }

            // console.log("Response producer:", response);

            // Reset form after co-Producer submission
            setFormData({
                details: '',
                dd_application_form_id: id,
            });
            loadData();
            // alert('Form has submitted successfully!');
            setAlertMessage('Data has been submitted successfully!');
            setAlertSeverity('success');
            setAlertOpen(true);
            //  await loadpreData();
        } catch (error) {
            console.error("Error: ", error);
            // alert('Error submitting form. Please try again later.');
            setAlertMessage('Error submitting form. Please try again later.');
            setAlertSeverity('error');
            setAlertOpen(true);
        } finally {
            setLoading(false); // Set loading to false when the API call finishes
        }
    };

    const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
    const [prepareDelete, setPrepareDelete] = useState(null);

    const handleDeleteOpen = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setPrepareDelete(value);
        setOpenDeleteConfirm(true);
    };

    const handleDeleteClose = (e) => {
        e.preventDefault();
        setOpenDeleteConfirm(false);
    };
    const submitDelete = async (e) => {
        e.preventDefault();
        setLoading(true)

        try {
            const response = await deleteRequest(`dd-award/${prepareDelete}`, formData)

            if (!response.status) {
                throw new Error(`Error: ${response.status} ${response.statusText}`);
            }
            loadData();
            // alert('Record deleted successfully!');
            setAlertMessage('Data has been deleted successfully!');
            setAlertSeverity('error');
            setAlertOpen(true);
            //  await loadpreData();
        } catch (error) {
            console.error("Error: ", error);
            // alert('Error submitting form. Please try again later.');
            setAlertMessage('Error submitting form. Please try again later.');
            setAlertSeverity('error');
            setAlertOpen(true);
        } finally {
            setLoading(false); // Set loading to false when the API call finishes
        }
        setOpenDeleteConfirm(false);
    };

    const toRoman = (num) => {
        const romanNumerals = [
            ["XL", 40],
            ["X", 10],
            ["IX", 9],
            ["V", 5],
            ["IV", 4],
            ["I", 1]
        ];

        let roman = "";
        for (let [letter, value] of romanNumerals) {
            while (num >= value) {
                roman += letter;
                num -= value;
            }
        }
        return roman;
    };

    return (
        <>
            {loading && <Loader />}
            <TableContainer component={Paper} style={{ marginTop: '10px' }}>
                <Table aria-label="caption table">
                    {
                        preData && preData.length > 0 ? (
                            <TableHead>
                                <TableRow>
                                    <TableCell align='center'>Sr. No.</TableCell>
                                    <TableCell align='center'>Details of the Awards won(if any)</TableCell>
                                    <TableCell align='center'>
                                        {maximumLimitReach ? (showForm ? (
                                            <Button onClick={mini}><IndeterminateCheckBoxIcon /></Button>
                                        ) : (
                                            <Button onClick={Addmore}><AddBoxIcon /></Button>
                                        )) : <></>}</TableCell>
                                </TableRow>
                            </TableHead>
                        ) : <></>
                    }
                    <TableBody>
                        {preData.map((row, index) => (
                            <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell align="center">({toRoman(index + 1)})</TableCell>
                                <TableCell align="center">{row.details}</TableCell>

                                <TableCell align="center">
                                    <Button value={row.id} onClick={handleDeleteOpen} variant="outlined" color="error" startIcon={<DeleteIcon style={{ color: '#d32f2f' }} />}>
                                        Delete
                                    </Button>
                                    <DeleteDialog open={openDeleteConfirm} handleClose={handleDeleteClose} handleDelete={submitDelete} />
                                </TableCell>
                            </TableRow>
                        ))}

                        {/* <TableFooter> */}
                        {
                            (showForm) ?
                                <TableRow>
                                    <TableCell align="center"></TableCell>
                                    <TableCell align="center">
                                        <Box>
                                            <TextField
                                                label="Details of the Awards won(if any)"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                name="details"
                                                value={formData.details}
                                                onChange={handleFormData}
                                            />
                                            {errorsForm.name && (
                                                <p className="text-danger">{errorsForm.details}</p>
                                            )}
                                        </Box>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Box>
                                            <Button variant="contained" color="success" onClick={submitForm}>
                                                Save
                                            </Button>
                                            {/* <Button className='btn btn-success' onClick={submitForm}>Submit and Add More</Button> */}
                                        </Box>
                                    </TableCell>
                                </TableRow> :
                                <></>
                        }
                    </TableBody>
                    {/* </TableFooter> */}
                </Table>
            </TableContainer>

            <Snackbar
                open={alertOpen}
                autoHideDuration={6000}
                onClose={() => setAlertOpen(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    onClose={() => setAlertOpen(false)}
                    severity={alertSeverity}
                    variant="filled"
                >
                    {alertMessage}
                </Alert>
            </Snackbar>

        </>
    )
}

export default IpAward